import React from 'react';
import IconSvg from '../../../img/trip_planner/steps/step_2.svg';
import {GPlacesAutocomplete2} from "@tripian/react";
import Model, { helper } from '@tripian/model';


interface TripProfile extends Model.TripProfile {
    numberOfChildren: number;
}

interface Step2DestinationProps {
    tripProfile: TripProfile;
    onUpdateTripProfile: (newProfile: React.SetStateAction<TripProfile>) => void;
    bound?: google.maps.LatLngBounds;
}

const Step2Destination = ({
    tripProfile,
    onUpdateTripProfile,
    bound
}: Step2DestinationProps) => {
    const callbackGPlacesAutocomplete = (googlePlace: google.maps.places.PlaceResult) => {
        const newTripProfile = helper.deepCopy(tripProfile);
        if (googlePlace.name === '') {
            newTripProfile.accommodation = undefined;
        } else {
            newTripProfile.accommodation = { name: googlePlace.name ?? null, provider: 'Google', imageUrl: '', refID: googlePlace.place_id ?? null, address: '', coordinate: { lat: 0, lng: 0 } };

            if (googlePlace.formatted_address) {
                newTripProfile.accommodation.address = googlePlace.formatted_address;
            }

            if (googlePlace.geometry) newTripProfile.accommodation.coordinate = { lat: googlePlace.geometry.location?.lat() || 1, lng: googlePlace.geometry.location?.lng() || 1 };
        }

        onUpdateTripProfile(newTripProfile);
    };
    // Onboarding - Stay
    return (
        <div className="space-y-6">
            <div className="text-center mb-8">
                <div className="w-20-h mx-auto mb-4 relative">
                    <img
                        src={IconSvg}
                        alt="Where are you going?"
                        className="w-full h-full object-contain"
                    />
                    <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', mixBlendMode: 'lighten' }} />
                </div>
                <h2 className="text-2xl font-semibold mb-2 syne-fm">Where are you staying?</h2>
            </div>

            <div className="space-y-4">
                <div>
                    <GPlacesAutocomplete2
                        initialText={tripProfile.accommodation ? `${tripProfile.accommodation.name || ''} ${tripProfile.accommodation.address || ''}` : ''}
                        onSelectedChanged={callbackGPlacesAutocomplete}
                        boundry={bound || undefined}
                        placeholder="Search for hotels"
                        onFocus={() => {}}
                        onBlur={() => {}}
                        showSearchIcon={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default Step2Destination;
